import { useContext } from "react";
import { useAppStore } from "../store/useAppStore";
import { AppContext } from "../App";
import api from "./api/api";
import AlertPopup from "./ui/AlertPopup";
import WarningIcon from "../icons/WarningIcon";

export default function UnprintedPopup() {
	const { shop, setConfirm } = useContext(AppContext);
	const { unprinted } = useAppStore();

	const sendThermalPrintersCommand = async (command) => {
		console.log("sendThermalPrintersCommand", command);

		setConfirm({
			title: "Sei sicuro?",
			onConfirm: async () => {
				const res = await api.postProtected("/thermal_printers/send_command/", {
					shop_id: shop.id,
					command: command,
				});
				if (res.success == 0)
					setConfirm({
						title: "Errore",
						message: res.error,
					});
			},
		});
	};

	if (unprinted == 0) return null;

	return (
		<AlertPopup className="alert-compact alert-print-errors">
			<div className="alert-compact-head">
				<WarningIcon className="alert-badge-icon" aria-hidden="true" />
				<strong className="alert-popup-title">Comande da stampare</strong>
			</div>
			<p className="alert-compact-message">
				{unprinted == 1
					? "1 comanda non è stata stampata."
					: `${unprinted} comande non sono state stampate.`}
			</p>
			<div className="alert-compact-actions">
				<button className="button" onClick={() => sendThermalPrintersCommand("check_unprinted")}>
					Stampa
				</button>
			</div>
		</AlertPopup>
	);
}
